var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      on: {
        "before-enter": _vm.appearAnimationBefore,
        enter: _vm.appearAnimationEnter,
        leave: _vm.appearAnimationLeave,
      },
    },
    [
      _vm.visible
        ? _c("div", { staticClass: "cookie-popup" }, [
            _c(
              "div",
              { staticClass: "container cookie-popup__body" },
              [
                _c(
                  "div",
                  [
                    _c(
                      "z-caption",
                      {
                        staticClass: "cookie-popup__title",
                        attrs: { tag: "p", size: "l" },
                      },
                      [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text.title) },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("vue-raw", {
                          staticClass: "cookie-popup__text",
                          attrs: { raw: _vm.text.description },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("transition", [
                  _vm.visibleSettings
                    ? _c("div", { staticClass: "cookie-popup__settings" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-default-3 col-tablet-5 col-mobile-12",
                            },
                            [
                              _c("div", { staticClass: "settings__title" }, [
                                _c(
                                  "h5",
                                  {
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.showInfo("policy")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.text.cookies.cookies_policy.title
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("label", { staticClass: "cookie-switch" }, [
                                  _c("input", {
                                    attrs: {
                                      type: "checkbox",
                                      disabled: "",
                                      checked: "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass:
                                      "cookie-switch--slider cookie-switch--locked",
                                  }),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", {
                                class: _vm.showText.policy
                                  ? "settings__text--show"
                                  : "settings__text",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.text.cookies.cookies_policy.description
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-default-3 col-tablet-5 col-tablet-offset-1 col-mobile-12 col-mobile-offset-0",
                            },
                            [
                              _c("div", { staticClass: "settings__title" }, [
                                _c(
                                  "h5",
                                  {
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.showInfo("performance")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.text.cookies.performance.title)
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("label", { staticClass: "cookie-switch" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.checkedCookies,
                                        expression: "checkedCookies",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      value: "performance",
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.checkedCookies)
                                        ? _vm._i(
                                            _vm.checkedCookies,
                                            "performance"
                                          ) > -1
                                        : _vm.checkedCookies,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                      change: function ($event) {
                                        var $$a = _vm.checkedCookies,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "performance",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.checkedCookies = $$a.concat([
                                                $$v,
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.checkedCookies = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.checkedCookies = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "cookie-switch--slider",
                                  }),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", {
                                class: _vm.showText.performance
                                  ? "settings__text--show"
                                  : "settings__text",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.text.cookies.performance.description
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-default-3 col-tablet-5 col-mobile-12",
                            },
                            [
                              _c("div", { staticClass: "settings__title" }, [
                                _c(
                                  "h5",
                                  {
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.showInfo("functional")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.text.cookies.functional.title)
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("label", { staticClass: "cookie-switch" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.checkedCookies,
                                        expression: "checkedCookies",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      value: "functional",
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.checkedCookies)
                                        ? _vm._i(
                                            _vm.checkedCookies,
                                            "functional"
                                          ) > -1
                                        : _vm.checkedCookies,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                      change: function ($event) {
                                        var $$a = _vm.checkedCookies,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "functional",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.checkedCookies = $$a.concat([
                                                $$v,
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.checkedCookies = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.checkedCookies = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "cookie-switch--slider",
                                  }),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", {
                                class: _vm.showText.functional
                                  ? "settings__text--show"
                                  : "settings__text",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.text.cookies.functional.description
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-default-3 col-tablet-5 col-tablet-offset-1 col-mobile-12 col-mobile-offset-0",
                            },
                            [
                              _c("div", { staticClass: "settings__title" }, [
                                _c(
                                  "h5",
                                  {
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.showInfo("marketing")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.text.cookies.marketing.title)
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("label", { staticClass: "cookie-switch" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.checkedCookies,
                                        expression: "checkedCookies",
                                      },
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      value: "marketing",
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.checkedCookies)
                                        ? _vm._i(
                                            _vm.checkedCookies,
                                            "marketing"
                                          ) > -1
                                        : _vm.checkedCookies,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                      change: function ($event) {
                                        var $$a = _vm.checkedCookies,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = "marketing",
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.checkedCookies = $$a.concat([
                                                $$v,
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.checkedCookies = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.checkedCookies = $$c
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "cookie-switch--slider",
                                  }),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", {
                                class: _vm.showText.marketing
                                  ? "settings__text--show"
                                  : "settings__text",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.text.cookies.marketing.description
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cookie-popup__buttons" },
                  [
                    !_vm.visibleSettings
                      ? [
                          _c(
                            "div",
                            { staticClass: "cookie-popup__button" },
                            [
                              _c(
                                "z-button",
                                {
                                  key: "confirm",
                                  attrs: { size: "m", kind: "primary" },
                                  on: { click: _vm.submit },
                                },
                                [_vm._v(_vm._s(_vm.text.button.confirm))]
                              ),
                            ],
                            1
                          ),
                        ]
                      : [
                          _c(
                            "div",
                            { staticClass: "cookie-popup__button" },
                            [
                              _c(
                                "z-button",
                                {
                                  key: "confirmAll",
                                  attrs: { size: "m", kind: "primary" },
                                  on: { click: _vm.submit },
                                },
                                [_vm._v(_vm._s(_vm.text.button.confirmAll))]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "cookie-popup__button" },
                            [
                              _c(
                                "z-button",
                                {
                                  key: "confirmSettings",
                                  attrs: { size: "m", kind: "secondary" },
                                  on: { click: _vm.submitSettings },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.text.button.confirmSettings)
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "cookie-popup__close",
                    on: { click: _vm.setVisibleFalse },
                  },
                  [
                    _c("z-icon", {
                      attrs: { name: "close_light", width: "32", height: "32" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }